import { render } from "./GameRules.vue?vue&type=template&id=66d864cc&scoped=true"
import script from "./GameRules.vue?vue&type=script&lang=js"
export * from "./GameRules.vue?vue&type=script&lang=js"

import "./GameRules.vue?vue&type=style&index=0&id=66d864cc&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d864cc"]])

export default __exports__